// Copyright ©️ 2026 eVolve MEP, LLC

import { Navigate, Route, Routes } from 'react-router';

import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import { useShowHighPriorityMessages } from 'app/MessageCenter/useShowHighPriorityMessages';
import { ModuleRoutes } from 'app/ModuleRoutes';
import { AutodeskAuth } from 'components/Autodesk/auth/AutodeskAuth';
import { autodeskAuthPath } from 'components/Autodesk/auth/helpers';
import { AuthenticationRoutes } from 'modules/Authentication/AuthenticationRoutes';
import { InvitationExpired } from 'modules/Authentication/InvitationExpired';
import { QrCodeRedirectPage } from 'modules/Shop/WorkOrders/QrCodeRedirectPage';

import { MessageCenterPage } from './MessageCenter/MessageCenterPage';
import { NoAccessibleRoutesLandingPage } from './NoAccessibleRoutesLandingPage';
import { PageNotFound } from './PageNotFound';
import { PrivateWrapper } from './PrivateWrapper';

export const AppRoutes = () => {
  useShowHighPriorityMessages();

  return (
    <Routes>
      <Route path="/" element={<PrivateWrapper />}>
        <Route path={`${moduleRoute}/*`} element={<ModuleRoutes />} />
        <Route path={`${moduleRoute}/qr-code/:qrCodeId`} element={<QrCodeRedirectPage />} />
        {/* Legacy routing for work requests. Remove eventually. */}
        <Route
          path={`${moduleRoute}/work-requests/*`}
          element={<Navigate to={`/${moduleRoute}/work-orders`} replace />}
        />
        <Route path="/message/" element={<MessageCenterPage />} />
        <Route path="/message/:messageId" element={<MessageCenterPage />} />

        {/* Backwards compatibility for old links to admin pages. Remove eventually. */}
        <Route path="/admin/*" element={<Navigate to="/" />} />

        <Route path="no-license" element={<NoAccessibleRoutesLandingPage />} />
      </Route>

      <Route path={autodeskAuthPath} element={<AutodeskAuth />} />
      <Route path="auth/*" element={<AuthenticationRoutes />} />
      <Route path="invitation-expired" element={<InvitationExpired />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
